function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_56",
  "data-name": "Group 56",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_55",
  "data-name": "Group 55"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_111",
  "data-name": "Path 111",
  d: "M88.556,202.135a133.144,133.144,0,0,0,88.9,169.634,2.815,2.815,0,0,0,1.573,0,133.145,133.145,0,0,0,88.89-169.634Z",
  transform: "translate(-71.835 -91.403)",
  fill: "#b4b4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  d: "M274.649,237.754a132.575,132.575,0,0,0-6.6-35.619H88.683a132.556,132.556,0,0,0-6.6,35.619Z",
  transform: "translate(-71.962 -91.403)",
  fill: "#b4b4b4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  d: "M344.825,244.076a133.066,133.066,0,0,1-95.643,127.7,2.807,2.807,0,0,1-1.571,0q-5.434-1.585-10.672-3.627a133.147,133.147,0,0,0,78.22-166.008h22.915A132.869,132.869,0,0,1,344.825,244.076Z",
  transform: "translate(-141.988 -91.405)",
  fill: "#b4b4b4"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_49",
  "data-name": "Group 49"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  d: "M260.978,13.087a4.166,4.166,0,0,0-4.922-3.248L238.32,13.474a49.917,49.917,0,0,0-6.752-11.9,4.172,4.172,0,1,0-6.529,5.194c11.027,13.858,12.851,43.457,12.868,43.755a4.171,4.171,0,0,0,4.161,3.933c.08,0,.16,0,.24-.007a4.172,4.172,0,0,0,3.928-4.4,137.759,137.759,0,0,0-5.1-28.639l16.595-3.4A4.165,4.165,0,0,0,260.978,13.087Z",
  transform: "translate(-136.196 0)",
  fill: "#989595"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_47",
  "data-name": "Group 47",
  transform: "translate(0 50.287)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_115",
  "data-name": "Path 115",
  d: "M267.674,173.276H70.335a6.724,6.724,0,0,1-6.724-6.724V132.841A41.045,41.045,0,0,1,104.656,91.8h128.7A41.045,41.045,0,0,1,274.4,132.841v33.711A6.724,6.724,0,0,1,267.674,173.276Z",
  transform: "translate(-63.611 -91.796)",
  fill: "#989595"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_48",
  "data-name": "Group 48",
  transform: "translate(148.259 50.285)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  d: "M396.774,132.843V166.55a6.722,6.722,0,0,1-6.724,6.724H368.567a6.722,6.722,0,0,0,6.724-6.724V132.843a41.046,41.046,0,0,0-41.043-41.05h21.483A41.046,41.046,0,0,1,396.774,132.843Z",
  transform: "translate(-334.248 -91.793)",
  fill: "#989595"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54",
  transform: "translate(36.102 50.284)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_50",
  "data-name": "Group 50",
  transform: "translate(0 0.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  d: "M173.559,91.792a41.907,41.907,0,0,0-35.729,37.081,4.172,4.172,0,0,1-4.144,3.732,3.994,3.994,0,0,1-.445-.028,4.168,4.168,0,0,1-3.7-4.589,50.152,50.152,0,0,1,21.608-36.2Z",
  transform: "translate(-129.512 -91.792)",
  fill: "#b4b4b4"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_51",
  "data-name": "Group 51",
  transform: "translate(94.537)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M342.4,132.576a4.126,4.126,0,0,1-.445.028,4.172,4.172,0,0,1-4.144-3.732,41.907,41.907,0,0,0-35.729-37.081H324.5a50.152,50.152,0,0,1,21.608,36.2A4.168,4.168,0,0,1,342.4,132.576Z",
  transform: "translate(-302.084 -91.791)",
  fill: "#b4b4b4"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_53",
  "data-name": "Group 53",
  transform: "translate(40.029 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_52",
  "data-name": "Group 52"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  d: "M257.219,132.59a4.311,4.311,0,0,1-4.455-3.926c-1.384-12.331-9.022-28.049-19.5-34.46a2.736,2.736,0,0,0-2.848.008c-10.531,6.452-18.19,22.3-19.51,34.66a4.176,4.176,0,0,1-4.144,3.732,4.087,4.087,0,0,1-.45-.028,4.172,4.172,0,0,1-3.7-4.588c1.3-12.175,7.547-26.952,17.348-36.2h23.782c9.8,9.244,16.046,24.022,17.348,36.2A4.169,4.169,0,0,1,257.219,132.59Z",
  transform: "translate(-202.583 -91.791)",
  fill: "#b4b4b4"
}))))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_58",
  "data-name": "Group 58",
  transform: "translate(69.558 220.829)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_57",
  "data-name": "Group 57"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_120",
  "data-name": "Path 120",
  d: "M198.329,415.575c-3.528,0-6.443-2.774-7.608-7.24a4.172,4.172,0,0,1,7.608-3.21,4.172,4.172,0,0,1,7.607,3.21c-1.164,4.466-4.078,7.241-7.607,7.241Z",
  transform: "translate(-190.585 -403.11)",
  fill: "#929292"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_60",
  "data-name": "Group 60",
  transform: "translate(88.945 237.333)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_59",
  "data-name": "Group 59"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_121",
  "data-name": "Path 121",
  d: "M233.718,445.7c-3.53,0-6.444-2.775-7.607-7.241a4.172,4.172,0,0,1,7.608-3.21,4.172,4.172,0,0,1,7.607,3.21c-1.165,4.466-4.08,7.24-7.608,7.24Z",
  transform: "translate(-225.975 -433.237)",
  fill: "#929292"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_62",
  "data-name": "Group 62",
  transform: "translate(156.234 151.005)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_61",
  "data-name": "Group 61"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_122",
  "data-name": "Path 122",
  d: "M356.55,288.115c-3.53,0-6.444-2.775-7.607-7.241a4.172,4.172,0,0,1,7.608-3.21,4.172,4.172,0,0,1,7.607,3.21C362.994,285.341,360.079,288.115,356.55,288.115Z",
  transform: "translate(-348.807 -275.65)",
  fill: "#929292"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_64",
  "data-name": "Group 64",
  transform: "translate(128.425 166.108)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_63",
  "data-name": "Group 63"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_123",
  "data-name": "Path 123",
  d: "M305.786,315.685c-3.53,0-6.444-2.775-7.607-7.242a4.172,4.172,0,0,1,7.608-3.209,4.172,4.172,0,0,1,7.607,3.21C312.23,312.91,309.315,315.685,305.786,315.685Z",
  transform: "translate(-298.043 -303.22)",
  fill: "#929292"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_66",
  "data-name": "Group 66",
  transform: "translate(39.678 167.691)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_65",
  "data-name": "Group 65"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_124",
  "data-name": "Path 124",
  d: "M143.784,318.574c-3.53,0-6.444-2.775-7.607-7.241a4.172,4.172,0,0,1,7.607-3.21,4.172,4.172,0,0,1,7.607,3.21C150.228,315.8,147.314,318.574,143.784,318.574Z",
  transform: "translate(-136.041 -306.109)",
  fill: "#929292"
})));

function SvgNut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nut",
    xmlns: "http://www.w3.org/2000/svg",
    width: 210.787,
    height: 280.481,
    viewBox: "0 0 210.787 280.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNut);
export default __webpack_public_path__ + "static/media/nut.a832af39.svg";
export { ForwardRef as ReactComponent };